//checkFieldPresenceInCriteria(payload, fieldName) {
// const checkFieldPresenceInCriteria = (criteria, fieldName) => {
//     let fieldNameFlag = false;
//     for (let j = 0; j < criteria.length; j++) {
//         const searchKeys = Object.keys(criteria[j]);
//         // console.log(searchKeys);
//         if (fieldName.includes(searchKeys[0])) {
//             fieldNameFlag = true;
//         }
//     }
//     return fieldNameFlag;
// }

// const getPositionInCriteria = (criteria, fieldName) => {
//     let position = -1;
//     for (let j = 0; j < criteria.length; j++) {
//         const searchKeys = Object.keys(criteria[j]);
//         if (fieldName.includes(searchKeys[0])) {
//             return j;
//         }
//     }
//     return position;
// }


// const getFieldValueInCriteria = (criteria, fieldName) => {
//     let fieldValue = [];
//     for (let j = 0; j < criteria.length; j++) {
//         const searchKeys = Object.keys(criteria[j]);
//         // console.log(searchKeys);
//         const temp = { ...criteria[j] };
//         if (fieldName.includes(searchKeys[0])) {
//             fieldValue = temp[`${fieldName}`];
//             break;
//         }
//     }
//     // console.log(' fieldValue '+fieldValue);
//     if (fieldValue.length > 0) {
//         return fieldValue[0];
//     }
//     return '';
// }

const getPayloadFunction = listType => {
    let payloadFunction

    switch (listType.toLowerCase()) {
        case 'property':
            payloadFunction = createPropertyPayload
            break
        // case 'account':
        //     payloadFunction = createAccountPayload
        //     break
        default:
    }

    return payloadFunction
}

const fillSearchFields = (searchFields, savedCriteria) => {

    // let criteria = JSON.parse(savedCriteria)
    // console.log('savedCriteria:::', savedCriteria)

    try {
        Object.keys(savedCriteria).forEach(item => {

            if (item === 'propertyLocation') {
                if (savedCriteria[item].region) {
                    searchFields['PropertyLocation'].region.forEach(region => {
                        if (savedCriteria[item].region.includes(region.fieldName)) {
                            region.isChecked = true
                        }
                    })
                }
                if (savedCriteria[item].selectedLocation) {
                    savedCriteria[item].selectedLocation.forEach(selectedLocations => {
                        let newselectedLocations = { ...selectedLocations }
                        let combinedLocation = ''
                        Object.keys(newselectedLocations).forEach(locs => {
                            combinedLocation = combinedLocation ? `${combinedLocation}, ${newselectedLocations[locs]}` : newselectedLocations[locs]
                        })
                        newselectedLocations.combinedLocation = combinedLocation
                        searchFields['PropertyLocation'].selectedLocations.push(newselectedLocations)
                    })
                }
            }

            if (item === 'propertyType') {
                searchFields['PropertyType'].forEach(type => {
                    if (savedCriteria[item].includes(type.fieldName)) {
                        type.isChecked = true
                    }
                })
            }

            if (item === 'affordableHousing') {
                searchFields['affordableHousing'] = savedCriteria['affordableHousing']
            }

            if (item === 'doNotaddAdditionalContacts') {
                searchFields['doNotaddAdditionalContacts'] = savedCriteria['doNotaddAdditionalContacts']
            }

            if (item === 'propertySales') {

                Object.keys(savedCriteria[item]).forEach(salesItem => {
                    searchFields['PropertySales'].forEach(type => {
                        if (salesItem === type.fieldName) {
                            type.minValue = savedCriteria[item][salesItem][0]
                            type.maxValue = savedCriteria[item][salesItem][1]
                        }
                    })

                })
            }

            if (item === 'propertyOtherInfo') {

                Object.keys(savedCriteria[item]).forEach(salesItem => {
                    searchFields['OtherInfo'].forEach(type => {
                        if (salesItem === type.fieldName) {
                            type.minValue = savedCriteria[item][salesItem][0]
                            type.maxValue = savedCriteria[item][salesItem][1]
                        }
                    })

                })
            }

            if (item === 'subjectPropertyCriteria') {
                //  "msa": "Modesto CA MSA", "units": 30, "yearBuilt": "1979" }
                Object.keys(savedCriteria[item]).forEach(key => {
                    if (key === 'propType') {
                        let subjectItem = ['omniViewPropertyType', savedCriteria[item][key]]
                        searchFields['SubjectProperty'].push(subjectItem)
                    }
                    if (key === 'cityState') {
                        let subjectItem = ['city', savedCriteria[item][key]]
                        searchFields['SubjectProperty'].push(subjectItem)
                    }
                    if (key === 'stateFilter') {
                        let subjectItem = ['state', savedCriteria[item][key]]
                        searchFields['SubjectProperty'].push(subjectItem)
                    }
                    if (key === 'msa') {
                        let subjectItem = ['MetropolitanStateAreaName', savedCriteria[item][key]]
                        searchFields['SubjectProperty'].push(subjectItem)
                    }
                    if (key === 'units') {
                        let subjectItem = ['propertyTotalUnits', savedCriteria[item][key]]
                        searchFields['SubjectProperty'].push(subjectItem)
                    }
                    if (key === 'yearBuilt') {
                        let subjectItem = ['yearBuilt', savedCriteria[item][key]]
                        searchFields['SubjectProperty'].push(subjectItem)
                    }
                    if (key === 'affordable') {
                        let subjectItem = ['propertyAffordableHousing', savedCriteria[item][key]]
                        searchFields['SubjectProperty'].push(subjectItem)
                    }
                    if (key === 'propertyName') {
                        let subjectItem = ['propertyName', savedCriteria[item][key]]
                        searchFields['SubjectProperty'].push(subjectItem)
                    }

                })
            }

            if (item === 'excludeClientPref') {
                searchFields.Filters[0].isChecked = true
            }

            if (item === 'excludeBrokers') {
                searchFields.Filters[1].isChecked = true
            }

            if (item === 'oldMergedLists') {
                savedCriteria[item].forEach(oldMergedListItem => {
                    searchFields['oldMergedLists'].push(oldMergedListItem)
                })
            }

            if (item === 'deletedContacts' && Array.isArray(savedCriteria[item])) {
                savedCriteria[item].forEach(deletedContact => {
                    searchFields['deletedContacts'].push(deletedContact)
                })
            }

            if (item === 'addedContacts' && Array.isArray(savedCriteria[item])) {
                savedCriteria[item].forEach(addedContact => {
                    searchFields['addedContacts'].push(addedContact)
                })
            }

        })
    } catch (error) {
        console.log('error:::', error)
    }

    return searchFields
}

const createPropertyPayload = searchFields => {
    let payload = {}

    let propertyLocation = { region: [], selectedLocation: [] }, propertyType = [],
        propertySales = { mostRecentSaleDate: [], mostRecentSalePrice: [], propertyPricePerUnit: [] },
        propertyOtherInfo = { yearBuilt: [], propertyTotalUnits: [], totalBeds: [] }, selectedLists = [],
        subjectPropertyCriteria = {}, addedContacts = [], deletedContacts = []

    searchFields['PropertyLocation'].region.forEach(item => {
        if (item.isChecked) {
            propertyLocation.region.push(item.fieldName)
        }
    })

    searchFields['PropertyLocation'].selectedLocations.forEach(item => {
        let newItem = { ...item }
        delete newItem.combinedLocation
        propertyLocation.selectedLocation.push(newItem)
    })

    searchFields['PropertyType'].forEach(item => {
        if (item.isChecked) {
            propertyType.push(item.fieldName)
        }
    })

    if(searchFields['affordableHousing'] !== undefined) {
        payload['affordableHousing'] = searchFields['affordableHousing']
    }

    if(searchFields['doNotaddAdditionalContacts'] !== undefined) {
        payload['doNotaddAdditionalContacts'] = searchFields['doNotaddAdditionalContacts']
    }

    searchFields['PropertySales'].forEach(item => {
        if (item.minValue || item.maxValue) {
            propertySales[item.fieldName].push(item.minValue, item.maxValue)
        }
        else {
            delete propertySales[item.fieldName]
        }
    })

    searchFields['OtherInfo'].forEach(item => {
        if (item.minValue || item.maxValue) {
            if (item.fieldName === 'propertyTotalUnits') {
                propertyOtherInfo['propertyTotalUnits'].push(item.minValue, item.maxValue)
                propertyOtherInfo['totalBeds'].push(item.minValue, item.maxValue)
            } else {
                propertyOtherInfo[item.fieldName].push(item.minValue, item.maxValue)
            }

        }
        else {
            if (item.fieldName === 'propertyTotalUnits') {
                delete propertyOtherInfo['totalBeds']
            }
            delete propertyOtherInfo[item.fieldName]
        }
    })

    searchFields['Filters'].forEach(item => {
        if (item.isChecked) {
            payload[item.fieldName] = true
        }
    })

    searchFields['SelectedLists'].forEach(item => {
        selectedLists.push(item.polarisEmailListId)
    })

    // console.log(searchFields['SubjectProperty'])
    searchFields['SubjectProperty'].forEach(item => {
        // propType: '', cityState: '', stateFilter: '', units: '', yearBuilt: '', affordable: ''
        if (item[0] === 'omniViewPropertyType') {
            subjectPropertyCriteria.propType = item[1]
        }
        if (item[0] === 'city') {
            subjectPropertyCriteria.cityState = item[1]
        }
        if (item[0] === 'state') {
            subjectPropertyCriteria.stateFilter = item[1]
        }
        if (item[0] === 'MetropolitanStateAreaName') {
            subjectPropertyCriteria.msa = item[1]
        }
        if (item[0] === 'propertyTotalUnits') {
            subjectPropertyCriteria.units = item[1]
        }
        if (item[0] === 'yearBuilt') {
            subjectPropertyCriteria.yearBuilt = item[1]
        }
        if (item[0] === 'propertyAffordableHousing') {
            subjectPropertyCriteria.affordable = item[1]
        }
        if (item[0] === 'propertyName') {
            subjectPropertyCriteria.propertyName = item[1]
        }

        // selectedLists.push(item.polarisEmailListId)
    })

    searchFields['addedContacts'].forEach(item => {
        addedContacts.push(item)
    })

    searchFields['deletedContacts'].forEach(item => {
        deletedContacts.push(item)
    })

    if (!propertyLocation.region.length) {
        delete propertyLocation.region
    }

    if (!propertyLocation.selectedLocation.length) {
        delete propertyLocation.selectedLocation
    }

    if (Object.keys(propertyLocation).length) {
        payload.propertyLocation = propertyLocation
    }

    if (propertyType.length) {
        payload.propertyType = propertyType
    }

    if (Object.keys(propertySales).length) {
        payload.propertySales = propertySales
    }

    if (Object.keys(propertyOtherInfo).length) {
        payload.propertyOtherInfo = propertyOtherInfo
    }

    if (selectedLists.length) {
        payload.mergeLists = selectedLists
    }

    if (searchFields['SubjectProperty'].length) {
        payload.subjectPropertyCriteria = subjectPropertyCriteria
    }

    if (addedContacts.length > 0) {
        payload.addedContacts = [...addedContacts]
    }

    if (deletedContacts.length > 0) {
        payload.deletedContacts = [...deletedContacts]
    }

    return payload
}

// `wait` milliseconds.
const debounce = (func, wait) => {
    let timeout

    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout)
            func(...args)
        }

        clearTimeout(timeout)
        timeout = setTimeout(later, wait)
    }
}

export {
    getPayloadFunction, createPropertyPayload, debounce, fillSearchFields
};